import { useQuery } from '@apollo/client';

import GET_ORGANIZATION_CHILDREN_QUERY from './graphql/get-organization-children-query.b2b.graphql';
import type {
  GetOrganizationChildrenQuery,
  GetOrganizationChildrenQueryVariables,
} from './graphql/types/GetOrganizationChildrenQuery';

type TUseOrganizationChildrenQueryProps = {
  slug: string;
  skip?: boolean;
};

export const useOrganizationChildrenQuery = ({
  slug,
  skip,
}: TUseOrganizationChildrenQueryProps) => {
  const { data, loading, error, ...organizationChildrenMethods } = useQuery<
    GetOrganizationChildrenQuery,
    GetOrganizationChildrenQueryVariables
  >(GET_ORGANIZATION_CHILDREN_QUERY, {
    fetchPolicy: 'cache-first',
    variables: {
      slug,
    },
    skip,
    context: { clientName: 'b2b' },
  });

  const organizationChildren = data?.organizationChildren?.length
    ? data.organizationChildren
    : [];

  return {
    loading,
    error,
    organizationChildren,
    organizationChildrenMethods,
  };
};
